<template>
    <div>
        <h3>Facturen waar borg is betaald</h3>
        <b-table
            :data="allInvoicesWithDeposit"
            :striped="true"
            :opened-detailed="[firstDepositInvoiceId]"
            :loading="loading"
            :mobile-cards="true"
            detailed
            detail-key="id"
            :show-detail-icon="true"
        >
            <template>
                <b-table-column v-slot="props" field="number" label="Factuur nr." width="160">
                    {{ props.row.number }}
                </b-table-column>

                <b-table-column v-slot="props" field="status" label="Status" width="200">
                    <!-- <b-tag :type="_.isNull(props.row.status) ? 'is-dark' : props.row.status == 'paid' ? 'is-success' : _.includes(['multiple_fails', 'storno'], props.row.status) ? 'is-danger' : _.includes(['one_fail'], props.row.status) ? 'is-warning' : _.includes(['cancelled', 'reminder_1', 'reminder_2'], props.row.status) ? 'is-warning' : 'is-info'">{{ invoiceStatus(props.row.status) }}</b-tag> -->
                    <InvoiceStatus
                        :id="props.row.id"
                        :send_at="props.row.send_at"
                        :status="props.row.status"
                    />
                    <!-- <b-tooltip label="Handmatige actie vereist" v-show="props.row.status != 'paid' && props.row.contract && props.row.contract.payment_type == 'manual'" style="float: left;margin-right: 5px;">
                        <b-icon icon="exclamation-circle" type="is-danger" />
                    </b-tooltip> -->
                </b-table-column>

                <b-table-column v-slot="props" field="total" label="Totaal" width="180">
                    <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                    <span v-else-if="props.row.total">€&nbsp;{{ props.row.total }}</span>
                    <span v-else>-</span>
                </b-table-column>

                <b-table-column v-slot="props" field="total" label="Borg" width="180">
                    <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                    <span v-else-if="getTotalDeposit(props.row.products)">€&nbsp;{{ getTotalDeposit(props.row.products) }}</span>
                    <span v-else>-</span>
                </b-table-column>

                <b-table-column v-slot="props" label="PDF" width="240">
                    <a :href="'/uploads'+props.row.pdf" target="_blank" v-if="props.row.pdf">Download PDF</a>
                    <span v-else>-</span>
                </b-table-column>

                <b-table-column v-slot="props" field="invoice_date" label="Datum" width="180">
                    {{ props.row.invoice_date|humanDate }}
                </b-table-column>

                <b-table-column v-slot="props" numeric width="100">
                    <b-button tag="router-link" type="is-dark" size="is-small" :to="{ name: 'InvoicesRecord', params: {type: 'verstuurd', id: props.row.id} }">Bekijken</b-button>
                </b-table-column>
            </template>

            <template #empty>
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p class="margin0" v-if="loading === false">Geen facturen met borg gevonden.</p>
                        <p class="margin0" v-else>Laden...</p>
                    </div>
                </section>
            </template>

            <template #detail="props">
                <div v-if="_.has(props, 'row.credit_invoices') && props.row.credit_invoices.length">
                    <b-table
                        :data="props.row.credit_invoices"
                        :striped="true"
                        :loading="loading"
                        :mobile-cards="true"
                    >
                        <template slot-scope="creditInvoice">
                            <b-table-column v-slot="props" field="number" label="Factuur nr." width="160">
                                {{ creditInvoice.row.number }}
                            </b-table-column>

                            <b-table-column v-slot="props" field="status" label="Status" width="150" sortable>
                                <b-tag :type="_.isNull(creditInvoice.row.status) ? 'is-dark' : creditInvoice.row.status == 'paid' ? 'is-success' : _.includes(['multiple_fails', 'storno'], creditInvoice.row.status) ? 'is-danger' : _.includes(['one_fail'], creditInvoice.row.status) ? 'is-warning' : _.includes(['cancelled', 'reminder_1', 'reminder_2'], creditInvoice.row.status) ? 'is-warning' : 'is-info'">{{ invoiceStatus(creditInvoice.row.status) }}</b-tag>
                            </b-table-column>

                            <b-table-column v-slot="props" field="total_price" label="Totaal" width="180">
                                <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                                <span v-else-if="creditInvoice.row.total" class="text-danger">-&nbsp;€&nbsp;{{ creditInvoice.row.total }}</span>
                                <span v-else>-</span>
                            </b-table-column>

                            <b-table-column v-slot="props" field="send_at" label="Verstuurd" width="180" sortable>
                                {{ creditInvoice.row.send_at || 'Nee' }}
                            </b-table-column>

                            <b-table-column v-slot="props" numeric width="100">
                                <b-button tag="router-link" type="is-dark" size="is-small" :to="{ name: 'InvoicesRecord', params: {type: 'credit', id: creditInvoice.row.id} }">Bekijken</b-button>
                            </b-table-column>
                        </template>
                    </b-table>
                </div>
                <div v-else>
                    <!-- If nog geen creditfactuur -->
                    <h4>Producten</h4>

                    <b-table
                        :data="props.row.products"
                        :striped="true"
                        :loading="loading"
                        :mobile-cards="true"
                        >
                        <b-table-column v-slot="props" field="name" label="Product" width="200">
                            {{ props.row.name }}
                        </b-table-column>

                        <b-table-column v-slot="props" field="name" label="Aantal" width="100">
                            {{ props.row.amount || 1 }}
                        </b-table-column>

                        <b-table-column v-slot="props" field="deposit" label="Borg" width="100">
                            <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                            <span v-else-if="props.row.deposit > 0">&euro;&nbsp;{{ number_format(props.row.deposit * (props.row.amount || 1)) }}</span>
                            <span v-else>-</span>
                        </b-table-column>

                        <b-table-column v-slot="props" field="price" label="Totaal" width="100">
                            <span v-if="hideSensitiveData">&euro;&nbsp;********</span>
                            <span v-else-if="props.row.price > 0">&euro;&nbsp;{{ number_format(props.row.price * (props.row.amount || 1)) }}</span>
                            <span v-else>-</span>
                        </b-table-column>
                    </b-table>
                </div>

                <br>

                <CreateCreditInvoiceButton
                    :deposit_products="props.row.deposit_products"
                    :products="props.row.products"
                    :customerId="props.row.customer"
                    :number="props.row.number"
                    :contractId="props.row.contract?.id"
                    :hasCredits="_.has(props, 'row.credit_invoices') && !!props.row.credit_invoices.length"
                />
            </template>
        </b-table>
    </div>
</template>

<script>
import filtersMixin from '@/mixins/filterMixins'
import CreateCreditInvoiceButton from '@/vue/creditinvoice/CreateCreditInvoiceButton'

export default {
    name: 'CustomerCredits',

    mixins: [filtersMixin],

    components: {
        CreateCreditInvoiceButton
    },

    props: {
        customerId: {
            type: Number|String,
            required: true
        }
    },

    data() {
        return {
            allInvoicesWithDeposit: [],
            // otherCreditInvoices: [],
            firstDepositInvoiceId: [],
            loading: false,
        }
    },

    computed: {
        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        },
        user() {
            return this.$store.state.user
        },
    },

    created() {
        if(this.customerId){
            this.fetchUserCredits()
        }
    },

    methods: {
        fetchUserCredits() {
            this.loading = true

            axios({
                method: 'get',
                    url: '/api/customer/'+this.customerId+'/deposits',
                headers: {'Authorization': 'bearer ' + this.$store.state.authToken}
            }).then((response) => {
                if(Object.keys(response.data.allInvoicesWithDeposit).length){
                    this.allInvoicesWithDeposit = Object.values(response.data.allInvoicesWithDeposit)
                }
                // if(Object.keys(response.data.otherCreditInvoices).length){
                //     this.otherCreditInvoices = Object.values(response.data.otherCreditInvoices)
                // }

                // Set ID to open first table item.
                if(this.allInvoicesWithDeposit.length){
                    this.firstDepositInvoiceId = this.allInvoicesWithDeposit[0].id
                }
            }).catch((error) => {
                console.error('[❌] Error while fetching customer credits ID '+this.customerId, error)
            }).then(() => {
                this.loading = false
            })

        },
        getTotalDeposit(products) {
            let total = 0

            _.each(products, (product) => {
                total += ((product.amount || 1) * product.deposit)
            })

            return this.number_format(total)
        },

        number_format(val, decimals = 2) {
            val = parseFloat(val)
            return val.toFixed(decimals)
        },
    }

}
</script>
